<script setup>
const isMobileMenuOpen = ref(false);
</script>

<template>
  <header
    class="bg-[#f5f5f5] dark:text-white dark:bg-[linear-gradient(109.63deg,var(--color-1)_3.67%,var(--color-2)_83.91%)] relative lg:mt-[114px] mt-[103px]"
  >
    <div
      class="flex justify-between items-center py-2 shadow-sm max-w-screen-xl mx-auto px-4 relative"
    >
      <!-- Logo -->
      <NuxtLink to="/services/maintenance-services/mobile-apps">
        <NuxtImg
          src="/images/flutter.webp"
          alt="Laravel Logo"
          width="150"
          height="40"
          loading="lazy"
          format="webp"
        />
      </NuxtLink>

      <!-- Desktop Navigation -->
      <nav class="text-[#2F2F2F] dark:text-white font-medium hidden md:flex">
        <NuxtLink
          to="/services/maintenance-services/mobile-apps"
          class="px-4 py-2 hover:bg-gray-200 dark:hover:bg-purple-500 duration-150 transition-colors"
        >
          Introduction
        </NuxtLink>
        <NuxtLink
          to="/services/maintenance-services/mobile-apps/maintenance"
          class="px-4 py-2 hover:bg-gray-200 dark:hover:bg-purple-500 duration-150 transition-colors"
        >
          Maintenance
        </NuxtLink>
        <NuxtLink
          to="/services/maintenance-services/mobile-apps/onboarding"
          class="px-4 py-2 hover:bg-gray-200 dark:hover:bg-purple-500 duration-150 transition-colors"
        >
          Onboarding
        </NuxtLink>
        <NuxtLink
          to="https://collab.webreinvent.com/client/login"
          class="px-4 py-2 hover:bg-gray-200 dark:hover:bg-purple-500 duration-150 transition-colors"
        >
          Client Login
        </NuxtLink>
      </nav>

      <!-- Toggle Button (Hamburger / Close) -->
      <button
        aria-label="hamburger menu"
        class="md:hidden focus:outline-none"
        @click="isMobileMenuOpen = !isMobileMenuOpen"
      >
        <svg
          v-if="!isMobileMenuOpen"
          class="w-6 h-6 text-[#2F2F2F] dark:text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          ></path>
        </svg>
        <svg
          v-else
          class="w-6 h-6 text-[#2F2F2F] dark:text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
    </div>

    <!-- Mobile Menu Dropdown -->
    <div
      v-if="isMobileMenuOpen"
      class="absolute right-4 top-[64px] bg-white dark:bg-[image:var(--bg-result-section)] border dark:border-none rounded-lg shadow-lg w-56 z-50 md:hidden"
    >
      <NuxtLink
        to="/services/maintenance-services/mobile-apps"
        class="block px-6 py-3 text-[#2F2F2F] dark:text-white dark:hover:bg-purple-500 dark:hover:text-white hover:text-[#FF2D20] hover:bg-gray-100"
        >Introduction
      </NuxtLink>
      <NuxtLink
        to="/services/maintenance-services/mobile-apps/maintenance"
        class="block px-6 py-3 text-[#2F2F2F] dark:text-white dark:hover:bg-purple-500 dark:hover:text-white hover:text-[#FF2D20] hover:bg-gray-100"
        >Maintenance</NuxtLink
      >
      <NuxtLink
        to="/services/maintenance-services/mobile-apps/onboarding"
        class="block px-6 py-3 text-[#2F2F2F] dark:text-white dark:hover:bg-purple-500 dark:hover:text-white hover:text-[#FF2D20] hover:bg-gray-100"
        >Onboarding</NuxtLink
      >
      <NuxtLink
        to="https://collab.webreinvent.com/client/login"
        class="block px-6 py-3 text-[#2F2F2F] dark:text-white dark:hover:bg-purple-500 dark:hover:text-white hover:text-[#FF2D20] hover:bg-gray-100"
        >Client Login
      </NuxtLink>
    </div>
  </header>
</template>
